import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore, useUserStore } from '@/store';
import util from '../../common/util';
import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import MenuItem from './menu-item.vue';
import ViewMore from '../../components/view-more.vue';
import HideSubdomain from '../../../../cms/src/util/hideSubdomain';
import MlsDisclaimer from './mls-disclaimer-v2.vue';
// import mls from './mls';
import closelyAppDownload from '../../components/download-closely';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import { OFFICE_DOMAIN } from 'lofty_region/const.js';
import PreferencePop from '@/components/cookieAuthority/theme/PreferencePop';
import CopyrightLink from './copyright-link.vue';
import { isHttpUrl } from '@/common/regexp.js';
const CUSTOM_COMPANY_ID = -99;
const DEFAULT_COMPANY_ID = -2;
const GROUP_NAME_VARIATE_ID = -3;
function jsonParse(obj) {
    let ret = '';
    try {
        ret = JSON.parse(obj);
    } catch (error) {
        ret = obj;
    }
    return ret;
}
export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-footer'
    },
    asyncData: mapAsyncData(asyncData),
    props: {
        inner: {
            type: Boolean,
            default: false
        }
    },
    mixins: [
        colorMixin({ '--bg-color': ['bgColor'] }, ['--g-bg-color']),
        spaceMixin()
    ],
    components: {
        MenuItem,
        ViewMore,
        MlsDisclaimer,
        closelyAppDownload,
        CopyrightLink
    },
    data: function() {
        return {
            expandKey: '',
            bgColor: '',
            fontColor: '',
            size: 100,
            logo: '',
            agentId: 0,
            hideCopyRight: false,
            year: new Date().getFullYear(),
            menus: [],
            fixed: false,
            footerAgentCustomContent: '',
            noMlsDisclaimers: [],
            logos: [],
            footerMenuStyle: {},
            footerSubMenuStyle: {},
            footerAgentInfoStyle: null,
            footerAgentNameStyle: {},
            footerAgentLicenseStyle: null,
            footerAgentPhoneStyle: {},
            footerAgentEmailStyle: {},
            footerBroNameStyle: {},
            footerBroAddrStyle: {},
            footerCopyRightStyle: {},
            chimeLink: OFFICE_DOMAIN,
            key: true,
            useMlsStyle: {},
            isShowAccessibility: true,
            hasTeaxsMls: false,
            companyNameId: '',
            customizeCompanyName: '',
            mlsOrgs: null,
            isDoNotShareShow: false
        };
    },
    inject: {
        footerData: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            global: store => store.page || {},
            showCopyright: store =>
                !(store.page?.['remove-copyright']?.removeCopyright ?? false),
            agentCreator: store => store.page?.agentCreator
        }),
        ...rootMapState(useUserStore, {
            user: store => store.user
        }),
        ...mapState({
            agents: store => store.agents,
            companyNameById: store => store.companyNameById,
            subdomainAgents: store => store.subdomainAgents,
            companyInfo: store => store.companyInfo,
            defaultCompanyName: store => store.defaultCompanyName,
            subOwnerInfo: store =>
                store.subdomainAgents?.length ? store.subdomainAgents[0] : null
        }),
        agent({ agents, agentCreator, agentId = 0 }) {
            if (agentId == 0 && agentCreator) {
                return agentCreator;
            }
            return agents[agentId] || agentCreator || {};
        },
        agentName({ agent, global }) {
            let content = [];
            if (!!agent.firstName || !!agent.lastName) {
                content.push(
                    `${agent.firstName || ''} ${agent.lastName || ''}`
                );
            }
            if (!!agent.license) {
                content.push(`${global.licenseName} ${agent.license}`);
            }
            return content.join(' | ').trim();
        },
        subOwnerName({ subOwnerInfo }) {
            if (!!subOwnerInfo?.firstName || !!subOwnerInfo?.lastName) {
                return `${subOwnerInfo.firstName || ''} ${
                    subOwnerInfo.lastName || ''
                }`.trim();
            }
        },
        socialNetworksInfo({ agent }) {
            const socialNetworksInfo = [].concat(
                agent?.agentSocialNetworks || []
            );
            return socialNetworksInfo.filter(item => {
                item.icon = 'icon-' + item.socialNetwork;
                if (item.socialNetwork === 'facebook') {
                    item.icon = 'icon-facebook-sign';
                }
                if (item.socialNetwork === 'google+') {
                    item.icon = 'icon-google1';
                }
                if (item.socialNetwork === 'twitter') {
                    item.icon = 'icon-newnewtwitter';
                }
                if (item.socialNetwork === 'tiktok') {
                    item.icon = 'icon-tik-tok';
                }
                return !!item.socialNetwork && isHttpUrl(item.url);
            });
        },
        isMobile() {
            return this.platform.isMobile;
        },
        teamId({ global }) {
            return global?.agentCreator?.teamId || '';
        },
        gfFlag({ global }) {
            //This attribute is relevant to the website package
            return global.gfFlag;
        },
        isSubSite({ global }) {
            return global.siteType == 3;
        },
        wordPressSSR({ global }) {
            return global.wordPressSSR;
        },
        validLogos() {
            return this.logos.filter(v => this.formatLogoUrl(v && v.logo));
        },
        afterApplySubdomain({ menus, isSubSite }) {
            isSubSite &&
                new HideSubdomain('', util.isSSRServer).applySetting(menus);
            return menus || [];
        },
        // z_menus() {
        //     return util
        //         .deepClone(this.afterApplySubdomain)
        //         .filter(item => this.hasPage(item));
        // },
        lpAgentFooter({ global }) {
            return global.siteType == 3 || !global.isLandingPage
                ? ',module:"footer"'
                : '';
        },
        footerAgentInfo({ agent }) {
            let ag = JSON.parse(JSON.stringify(agent));
            if (ag?.disclaimerList?.length) {
                ag.disclaimerList = ag.disclaimerList.map(
                    ({ fileName = '', queryLink = '' }) => ({
                        url: queryLink,
                        name: fileName
                    })
                );
            }
            let officeAddress = jsonParse(ag.officeAddress);
            ag._officeAddress =
                officeAddress && typeof officeAddress === 'string'
                    ? officeAddress
                    : officeAddress?.googleAddress || '';
            return ag;
        },
        getAddressInfo({ subOwnerInfo }) {
            //address obtain site owner's if website is subdomain
            let siteOwnerAddress = null;
            if (subOwnerInfo) {
                siteOwnerAddress = subOwnerInfo.address;
            }
            return (
                siteOwnerAddress ||
                this.footerAgentInfo?.address ||
                this.footerAgentInfo?._officeAddress ||
                this.companyInfo?.address
            );
        },
        agentHasDisclaimer({ footerAgentInfo }) {
            return (
                footerAgentInfo &&
                Array.isArray(footerAgentInfo?.disclaimerList) &&
                footerAgentInfo?.disclaimerList.length > 0
            );
        },
        subOwnerHasDisclaimer({ subOwnerInfo }) {
            return (
                subOwnerInfo &&
                Array.isArray(subOwnerInfo?.disclaimerList) &&
                subOwnerInfo?.disclaimerList.length > 0
            );
        },
        z_menus() {
            return (util.deepClone(this.menus) || []).filter(item =>
                this.hasPage(item));
        }
    },
    created() {
        if (this.footerData) {
            Object.keys(this.footerData).forEach(
                key => (this[key] = this.footerData[key])
            );
        }
    },
    mounted() {
        this.getNotShareData();
    },
    methods: {
        ...mapActions({
            getAgentInfo: 'getAgentInfo',
            getCompanyInfo: 'getCompanyInfo',
            getCompanyNameById: 'getCompanyNameById',
            getSubdomainAgents: 'getSubdomainAgents',
            getGroupName: 'getGroupName'
        }),
        getNotShareData() {
            this.axiosIns('/api-site/dsar/whitelist').then(res => {
                this.isDoNotShareShow = res.data?.inWhitelist;
            });
        },
        formatLogoUrl(logo) {
            if (logo) {
                if (logo.imgUrl) {
                    return logo.imgUrl;
                } else if (typeof logo === 'string') {
                    return logo;
                }
            }
            return false;
        },
        hasPage(menu) {
            if (menu.name.length > 50) {
                menu.name = menu.name.slice(0, 50) + '...';
            }
            
            // 特定菜单（如 owner）需要登录才显示
            if (menu.link?.toLowerCase().trim() === '/owner') {
                if (!this.user) {
                    return false;
                }
            }
            
            if (
                !(
                    menu.visible == 1 ||
                    (this.isMobile && menu.visible == 3) ||
                    (!this.isMobile && menu.visible == 2)
                )
            ) {
                return false;
            }
            if (menu.items) {
                menu.items = menu.items.filter(item => {
                    return this.hasPage(item);
                });
                if (menu.items.length > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        updateExpandKey(key) {
            this.expandKey = key;
        },
        async setCompanyName(id, item) {
            switch (id) {
            case '':
                break;
            case CUSTOM_COMPANY_ID: {
                this.companyInfo.name =
                        item?.name || this.customizeCompanyName;
                break;
            }
            case GROUP_NAME_VARIATE_ID: {
                try {
                    if (window.top.SiteInfo?.isTemplateSite) {
                        this.companyInfo.name = `{Group Name}`;
                    } else {
                        this.companyInfo.name = await this.getGroupName();
                    }
                } catch (error) {
                    console.error(error);
                    this.companyInfo.name = await this.getGroupName();
                }
                break;
            }
            case DEFAULT_COMPANY_ID: {
                this.companyInfo.name = this.defaultCompanyName;
                break;
            }
            default: {
                this.companyInfo.name = await this.getCompanyNameById(
                    id,
                    this.teamId
                );
            }
            }
        },
        mlsUpdated(mlsOrgs) {
            const hasTeaxsMls = mlsOrgs =>
                mlsOrgs.some(m => {
                    let str = m.state || '';
                    if (!str) {
                        return false;
                    }
                    return str.split(',').some(v => v.toUpperCase() === 'TX');
                });
            this.hasTeaxsMls = hasTeaxsMls(mlsOrgs);
        },
        onOpenCookieSetting() {
            PreferencePop();
        }
    },
    unmounted() {
        this.wmo && this.wmo.disconnect();
    }
};
